import { bulkDeleteDocuments } from '../../../actions'

/**
 * Belge silme metodlarını oluşturur
 *
 * @param {Object} state - Uygulama state
 * @param {Object} services - Servisler
 * @param {Object} loadMethods - Yükleme metodları
 * @returns {Object} Belge silme metodları
 */
export const createDocumentDeleteMethods = (state, services, loadMethods) => {
  const {
    documentToDelete,
    showDeleteConfirm,
    documents,
    allDocuments,
    isDeleting,
  } = state

  const {
    assetStore,
    axios,
    settings,
    responseHandlerService,
  } = services

  /**
   * Bir belgeyi silmek için hazırlık yapar
   *
   * @param {String} documentId - Silinecek belgenin ID'si
   */
  const handleDeleteDocument = (documentId) => {
    // Silme işlemi için belgeyi ve onay modalını hazırla
    documentToDelete.value = documentId
    showDeleteConfirm.value = true
  }

  /**
   * Belge silmeyi onayla
   * @param {Array} ids - Silinecek belge ID'leri (opsiyonel)
   */
  const confirmDeleteDocument = async (ids) => {
    try {
      const documentIds = ids || (documentToDelete.value ? [documentToDelete.value] : [])

      if (!documentIds || documentIds.length === 0) {
        if (state.deleteErrorMessage) {
          state.deleteErrorMessage.value = 'Silmek için belge seçilmedi'
        }
        return
      }

      state.isDeleting.value = true

      // Belgeleri toplu silme işlemini çağır
      await handleBulkDeleteDocuments(documentIds)

      // Başarılı silme işlemi - temizlik işlemleri
      state.documentToDelete.value = null
      state.showDeleteConfirm.value = false

      // Seçili belgeleri temizle
      if (state.selectedDocumentIds) {
        state.selectedDocumentIds.value = []
      }

      // Belgeleri yeniden yükle
      await loadMethods.loadDocuments()
    } catch (error) {
      console.error('Belge silme hatası:', error)
      if (state.deleteErrorMessage) {
        state.deleteErrorMessage.value = ids && ids.length > 1
            ? 'Belgeler silinirken bir hata oluştu. Lütfen tekrar deneyin.'
            : 'Belge silinirken bir hata oluştu. Lütfen tekrar deneyin.'
      }
    } finally {
      state.isDeleting.value = false
    }
  }

  /**
   * Belge silmeyi iptal et
   */
  const cancelDeleteDocument = () => {
    documentToDelete.value = null
    showDeleteConfirm.value = false
  }

  /**
   * Toplu belge silme işlemi
   *
   * @param {Array} documentIds - Silinecek belge ID'leri
   */
  const handleBulkDeleteDocuments = async (documentIds) => {
    if (!documentIds || documentIds.length === 0) return
    state.isDeleting.value = true

    // Silinen belgelere spinner ekle
    documentIds.forEach(docId => {
      const docIndex = documents.value.findIndex(doc => doc.id === docId)
      if (docIndex !== -1) {
        documents.value[docIndex] = { ...documents.value[docIndex], isDeleting: true }
      }
    })

    try {
      // Belgeleri toplu sil
      await bulkDeleteDocuments({
        axios,
        settings,
        assetId: assetStore.assetId,
        documentIds: documentIds,
      })

      // Belgeler listesinden kaldır
      documents.value = documents.value.filter(doc => !documentIds.includes(doc.id))

      // Tüm belgeleri güncelle
      documentIds.forEach(docId => {
        const allDocIndex = allDocuments.value.findIndex(doc => doc.id === docId)
        if (allDocIndex !== -1) {
          allDocuments.value.splice(allDocIndex, 1)
        }
      })

      // Seçili belgeleri temizle
      if (state.selectedDocumentIds) {
        state.selectedDocumentIds.value = []
      }

      responseHandlerService.handleSuccess(
          documentIds.length > 1
              ? `${documentIds.length} belge başarıyla silindi`
              : 'Belge başarıyla silindi',
      )

      // Seçilen belgeleri temizle ve diyaloğu kapat
      cancelDeleteDocument()
    } catch (error) {
      // Hata durumunda spinner'ları kaldır
      documentIds.forEach(docId => {
        const docIndex = documents.value.findIndex(doc => doc.id === docId)
        if (docIndex !== -1 && documents.value[docIndex]) {
          documents.value[docIndex].isDeleting = false
        }
      })
      responseHandlerService.handleError(error, 'Belge(ler) silinirken bir hata oluştu')
    } finally {
      state.isDeleting.value = false
    }
  }

  // Public API
  return {
    handleDeleteDocument,
    confirmDeleteDocument,
    cancelDeleteDocument,
    handleBulkDeleteDocuments,
  }
}